import { render, staticRenderFns } from "./ComponentFields.vue?vue&type=template&id=edd61fc6&scoped=true"
import script from "./ComponentFields.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentFields.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComponentFields.vue?vue&type=style&index=0&id=edd61fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd61fc6",
  null
  
)

export default component.exports